<div class="fn-mobile-table-header">
    <div class="fn-mobile-table-header__section-title">
      {{ this.titleTranslate | translate }}
    </div>
  </div>